import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'elx-imagemodal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatTooltipModule],
  templateUrl: './imagemodal.component.html',
  styleUrls: ['./imagemodal.component.scss'],
})
export class ImagemodalComponent {
  constructor(
    public dialogRef: MatDialogRef<ImagemodalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any = []
  ) { }

  public currentIndex = 0; // Initial current index

  public showPrevious() {
    this.currentIndex =
      (this.currentIndex - 1 + this.data.length) % this.data.length;
  }

  public showNext() {
    this.currentIndex = (this.currentIndex + 1) % this.data.length;
  }

  public changeSlide(index: number): void {
    this.currentIndex = index;
  }
}
